import RawMaterialGroup from '../models/RawMaterialGroup';
import MaterialColorFabricReference from '../models/MaterialColorFabricReference';
import apiClient from '../components/apiClient';

export class RawMaterialGroupService {
    static addRawMaterialGroup(rawMaterialGroup: RawMaterialGroup) : Promise<RawMaterialGroup> {
        return apiClient.post<RawMaterialGroup>(`/RawMaterialGroup/AddRawMaterialGroup`, rawMaterialGroup).then(res => res.data);
    }

    static getRawMaterialGroups() : Promise<RawMaterialGroup[]> {
        return apiClient.get<RawMaterialGroup[]>(`/RawMaterialGroup/GetRawMaterialGroups`).then(res => res.data);
    }
    
    static getRawMaterialGroup(id: number) : Promise<RawMaterialGroup> {
        return apiClient.get<RawMaterialGroup>(`/RawMaterialGroup/GetRawMaterialGroup/${id}`).then(res => res.data);
    }

    static updateRawMaterialGroup(rawMaterialGroup: RawMaterialGroup) : Promise<boolean> {
        return apiClient.put<boolean>(`/RawMaterialGroup/UpdateRawMaterialGroup`, rawMaterialGroup).then(res => res.data);
    }

    static deleteRawMaterialGroup(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/RawMaterialGroup/DeleteRawMaterialGroup/${id}`).then(res => res.data);
    }

    static addMaterialColorFabricReference(materialColorFabricReference: MaterialColorFabricReference) : Promise<MaterialColorFabricReference> {
        return apiClient.post<MaterialColorFabricReference>(`/RawMaterialGroup/AddMaterialColorFabricReference`, materialColorFabricReference).then(res => res.data);
    }

    static getMaterialColorFabricReferences(id: number) : Promise<MaterialColorFabricReference[]> {
        return apiClient.get<MaterialColorFabricReference[]>(`/RawMaterialGroup/GetMaterialColorFabricReferences/${id}`).then(res => res.data);
    }

    static updateMaterialColorFabricReference(materialColorFabricReference: MaterialColorFabricReference) : Promise<boolean> {
        return apiClient.put<boolean>(`/RawMaterialGroup/UpdateMaterialColorFabricReference`, materialColorFabricReference).then(res => res.data);
    }

    static deleteMaterialColorFabricReference(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/RawMaterialGroup/DeleteMaterialColorFabricReference/${id}`).then(res => res.data);
    }
}